import React, {useEffect, useState} from 'react';
import Textarea from "../../../../../../../components/input/textarea";
import Text from "../../../../../../../components/input/text";
import {Button} from "react-bootstrap";
import Icon from "../../../../../../../components/icon";
import {Modal} from "../../../../../../../components/modal";


const ImageSelector = ({onClick}) => {
    return (
        <Button
            size="sm"
            variant="secondary"
            className="btn-icon"
            onClick={onClick}
            style={{marginTop: '-6px', marginRight: '-6px'}}
        >
            <Icon name="image" style={{fontSize: 16}}/>
        </Button>
    )
}


export default function TextInput(
    {helperText, hasImage, label, placeholder, rows, InputProps, defaultValue, onChange}
) {
    const [value, setValue] = useState(defaultValue);
    const [showModal, setShowModal] = useState(false);
    const isMultiline = typeof rows === 'number' && rows > 1;

    const handleChange = (ev) => {
        const v = ev.target.value;
        setValue(v);
        onChange(v);
    }

    useEffect(() => {
        setValue(defaultValue)
    }, [defaultValue]);


    return (
        <>
            {
                isMultiline
                    ? <Textarea
                        required
                        controlled
                        size="md"
                        label={label}
                        value={value}
                        isReady={true}
                        placeholder={placeholder}
                        onChange={handleChange}
                    />
                    :
                    <Text
                        size="md"
                        controlled
                        name="country"
                        label={label}
                        isReady={true}
                        value={value}
                        placeholder={placeholder}
                        onChange={handleChange}
                        suffix={
                            hasImage && <ImageSelector onClick={() => setShowModal(true)}/>
                        }
                    />
            }
            <Modal size="lg" show={showModal} onClose={() => setShowModal(false)}>
                <div className="images-modal-wrapper">
                    <div className="image-modal" onClick={() => {
                        setValue('https://correos.idnurt.com/static/correos/cabecera-correos.png')
                        onChange('https://correos.idnurt.com/static/correos/cabecera-correos.png');
                        setShowModal(false)
                    }}>
                        <img src="https://correos.idnurt.com/static/correos/cabecera-correos.png" alt="cabecera correos" />
                    </div>


                    <div className="image-modal" onClick={() => {
                        setValue('https://correos.idnurt.com/static/correos/localizador.png')
                        onChange('https://correos.idnurt.com/static/correos/localizador.png');
                        setShowModal(false)
                    }}>
                        <img src="https://correos.idnurt.com/static/correos/localizador.png" alt="localizador correos" />
                    </div>



                    <div className="image-modal" onClick={() => {
                        setValue('https://correos.idnurt.com/static/correos/banner-2.png')
                        onChange('https://correos.idnurt.com/static/correos/banner-2.png');
                        setShowModal(false)
                    }}>
                        <img src="https://correos.idnurt.com/static/correos/banner-2.png" alt="banner 2 correos" />
                    </div>


                    <div className="image-modal" onClick={() => {
                        setValue('https://correos.idnurt.com/static/correos/banner-4.png')
                        onChange('https://correos.idnurt.com/static/correos/banner-4.png');
                        setShowModal(false)
                    }}>
                        <img src="https://correos.idnurt.com/static/correos/banner-4.png" alt="banner 4 correos" />
                    </div>


                    <div className="image-modal" onClick={() => {
                        setValue('https://correos.idnurt.com/static/correos/sample-image.jpg')
                        onChange('https://correos.idnurt.com/static/correos/sample-image.jpg');
                        setShowModal(false)
                    }}>
                        <img src="https://correos.idnurt.com/static/correos/sample-image.jpg" alt="imagen de ejemplo" />
                    </div>
                </div>
            </Modal>
        </>
    );
}
